import React from 'react'
import Menu from './components/Menu'
import FooterHome from './components/FooterHome'
import { LayoutWithStandardHeader as Layout, LayoutSidebar, Box } from 'stylist'
import { NavLink, Switch, Redirect, Route } from 'react-router-dom'
import RouteCompanies from 'routes/admin/companies'
import RouteCompany from 'routes/admin/companies/company'
import RouteCompanyNew from 'routes/admin/companies/new'
import RouteUsers from 'routes/admin/users'
import RouteUser from 'routes/admin/users/user'
import RouteUserNew from 'routes/admin/users/new'
import RouteProducts from 'routes/admin/products'
import RouteProduct from 'routes/admin/products/product'
import RouteFeatures from 'routes/admin/features'
import RouteFeature from 'routes/admin/features/feature'
import RouteServers from 'routes/admin/servers'
import RouteServersNew from 'routes/admin/servers/new'
import RouteServer from 'routes/admin/servers/server'
import { css } from 'react-emotion'

const activeClass = css`
  font-weight: bold;
`

const { Content, Sidebar } = LayoutSidebar
const { Item } = Box

const RouteAdmin = ({ match: { path, url } }) => (
  <Layout>
    <Layout.Header homeRoute="/">
      <Menu />
    </Layout.Header>
    <Layout.Main>
      <LayoutSidebar>
        <Sidebar>
          <Box ghost>
            <Item>
              <NavLink to={`${url}/companies`} activeClassName={activeClass}>
                Companies
              </NavLink>
            </Item>
            <Item>
              <NavLink to={`${url}/users`} activeClassName={activeClass}>
                Users
              </NavLink>
            </Item>
            <Item>
              <NavLink to={`${url}/products`} activeClassName={activeClass}>
                Products
              </NavLink>
            </Item>
            <Item>
              <NavLink to={`${url}/servers`} activeClassName={activeClass}>
                Servers
              </NavLink>
            </Item>
            <Item>
              <NavLink to={`${url}/features`} activeClassName={activeClass}>
                Feature Flags
              </NavLink>
            </Item>
          </Box>
        </Sidebar>
        <Content>
          <Switch>
            <Route
              path={path}
              exact
              render={() => <Redirect to={{ pathname: `${url}/companies` }} />}
            />
            <Route
              path={`${path}/companies`}
              exact
              component={RouteCompanies}
            />
            <Route path={`${path}/companies/new`} component={RouteCompanyNew} />
            <Route path={`${path}/companies/:id`} component={RouteCompany} />
            <Route path={`${path}/users`} exact component={RouteUsers} />
            <Route path={`${path}/users/new`} component={RouteUserNew} />
            <Route path={`${path}/users/:id`} component={RouteUser} />
            <Route path={`${path}/products`} exact component={RouteProducts} />
            <Route path={`${path}/products/:id`} component={RouteProduct} />
            <Route path={`${path}/features`} exact component={RouteFeatures} />
            <Route path={`${path}/features/:name`} component={RouteFeature} />
            <Route path={`${path}/servers`} exact component={RouteServers} />
            <Route
              path={`${path}/servers/new`}
              exact
              component={RouteServersNew}
            />
            <Route path={`${path}/servers/:id`} component={RouteServer} />
          </Switch>
        </Content>
      </LayoutSidebar>
    </Layout.Main>
    <Layout.Footer dark>
      <FooterHome />
    </Layout.Footer>
  </Layout>
)

export default RouteAdmin



// WEBPACK FOOTER //
// ./src/routes/admin.js